/* eslint-disable @typescript-eslint/no-explicit-any */
// Hook do aktualizacji klienta handlowca – PUT /sales-crm/clients/:id

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { IPostTraderClientRequest } from './usePostTraderClient';

const requestKeys = [
  'name',
  'street',
  'postal_code',
  'city',
  'country',
  'tax_number',
  'first_name',
  'last_name',
  'email',
  'phone',
  'name_address',
  'building',
  'house_number',
  'apartment',
  'apartment_number',
  'trade_credit_free',
  'trade_credit_total',
  'credibility_status',
  'last_credibility_report_date'
];

export interface IPutTraderClientRequest extends Pick<IPostTraderClientRequest, 'name' | 'id_external' | 'is_active' | 'tax_number' | 'client_group_id'> {
  name: string;
  street: string;
  postal_code: string;
  city: string;
  country: string;
  tax_number: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  name_address?: string;
  building?: string;
  house_number?: string;
  apartment?: string;
  apartment_number?: string;
  trade_credit_free?: string;
  trade_credit_total?: string;
  credibility_status?: string;
  last_credibility_report_date?: string;
}

type IResponse = ICommandResponseSuccess;

const putTraderClient = (clientId: number, data: IPutTraderClientRequest): Promise<IResponse> =>
  axios.put(`/sales-crm/clients/${clientId}`, data, {
    env: { FormData: { requestKeys } as any }
  });

export const usePutTraderClient = (
  clientId: number,
  options?: UseMutationOptions<IResponse, IError, IPutTraderClientRequest>
) => useMutation((data: IPutTraderClientRequest) => putTraderClient(clientId, data), options);
